import React from 'react';
import { Container } from './styles.js'

export default function Header() {
	return (
		<Container>
			<h1>Pipefy</h1>
		</Container>
	)
}